import { render, staticRenderFns } from "./OtherShippersTable.vue?vue&type=template&id=19934bec&scoped=true"
import script from "./OtherShippersTable.vue?vue&type=script&lang=js"
export * from "./OtherShippersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19934bec",
  null
  
)

export default component.exports